import React from "react";

const Dashboard = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-4">Dashboard</h1>
      <p>Welcome to the Admin Dashboard.</p>
    </div>
  );
};

export default Dashboard;
